import React from 'react';
import PropTypes from 'prop-types';

const Width = window.innerWidth < 600 ? '560' : '800';
const Height = window.innerWidth < 600 ? '315' : '450';
export const YoutubePlaylists = [
  {
    page: 'activities',
    type: 'volleyball',
    embedId: 'JgM_l3yPdK4?si=CqtxlzgdyFdM9EIG',
    videoTitle: '活力秘技',
  },
  {
    page: 'activities',
    type: 'pickleball',
    embedId:
      'height=315&href=https%3A%2F%2Fwww.facebook.com%2F100199211834510%2Fvideos%2F565383644898394%2F&show_text=false&width=560&t=0',
    videoTitle: '???',
  },
  { page: 'activities', type: 'hiking', embedId: '???', videoTitle: '???' },
];

const YoutubeEmbed = ({ embedId, videoTitle, width, height }) => {
  return (
    <div>
      <iframe
        width={width}
        height={height}
        src={`https://www.youtube.com/embed/${embedId}`}
        title={videoTitle}
        frameborder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        referrerpolicy='strict-origin-when-cross-origin'
        allowfullscreen='true'></iframe>
    </div>
  );
};

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
  videoTitle: PropTypes.string.isRequired,
};

export default YoutubeEmbed;

export const FacebookEmbed = ({ embedId, videoTitle, width, height }) => {
  return (
    <div>
      <iframe
        src={`https://www.facebook.com/plugins/video.php?${embedId}`}
        width={width}
        height={height}
        style={{ border: 0, overflow: 'hidden' }}
        title={videoTitle}
        frameborder='0'
        allowfullscreen='true'
        allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
        allowFullScreen='true'></iframe>
    </div>
  );
};

FacebookEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
  videoTitle: PropTypes.string.isRequired,
};
